import { contestantNames } from './contestant-roster.ts'

// Add only organizer-approved public profiles and licensed event media here.
// This public collection is separate from private application submissions.
export type ContestantProfile = {
  number: number
  nickname: string
  fullName: string
  age: number
  profession: string
  province: string
  photo: string
  wellnessStory: string
  personalSlogan: string
  whyIJoin: string
}
export type TeamMember = { name: string; role: string; organization: string; bio: string; photo: string }
export const galleryCategories = ['Miss Wellness World', 'Empress Activities', 'Workshop', 'Contestants', 'Media', 'Behind the Scenes'] as const
export type GalleryCategory = typeof galleryCategories[number]
export type GalleryItem = { id: string; category: GalleryCategory; src: string; alt: string; caption: string }

// The organizer's current public roster is separate from private applications.
export const rosterSummary = { count: contestantNames.length, asOf: '25 กันยายน 2569' }
export const contestants: ContestantProfile[] = []
export const teamMembers: TeamMember[] = []
export const galleryItems: GalleryItem[] = []
